import { configureStore } from "@reduxjs/toolkit";
import reducers from "./reducers";
import initialState from "./state";
import { APPLY_UPDATER } from "./actionTypes";

export { APPLY_UPDATER };

/**
 * Root reducer — supports:
 * - `{ type: APPLY_UPDATER, updater }` from custom connect/setStore
 * - `{ type: string }` looked up in `./reducers`
 * - legacy `{ type: Function }` (kept for safety)
 */
function createRootReducer(preloaded = initialState) {
  return function rootReducer(state = preloaded, action) {
    if (action?.type === APPLY_UPDATER && typeof action.updater === "function") {
      return action.updater(state, action);
    }
    if (typeof action?.type === "function") {
      return action.type(state, action);
    }
    if (typeof action?.type === "string") {
      return reducers[action.type]
        ? reducers[action.type](state, action)
        : state;
    }
    return state;
  };
}

/**
 * Factory matching the previous `createStore` API: `store()` / `store(state)`.
 */
const Store = function (state = initialState) {
  return configureStore({
    reducer: createRootReducer(state),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
        actionCreatorCheck: false,
      }),
    devTools: import.meta.env.DEV,
  });
};

export default Store;
